import ActiviteArchive from "./components/ActiviteArchive";

(function(){
    const {ready,isGutenberg} = cdm_blocks.fn;
    ready(function(){
        if(!isGutenberg()){
            const container = document.querySelector(".activitearchive");
            if(container){
                ReactDOM.render(<ActiviteArchive titleBar={document.querySelector(".banner h1")} />, container);
            }   
        }
    })
})()